// import styled from 'styled-components';
// import { animated } from 'react-spring';

// const Main = styled.div`
//   flex: 1;
//   display: flex;
//   height: 100%;
//   max-height: calc(100vh - 75px);

//   h2 {
//     font-size: 28px;
//     font-weight: bold;
//     color: #2c405a;
//     margin-bottom: 20px;
//   }
// `;

// Main.Container = styled.div`
//   flex: 1;
//   display: flex;
//   flex-direction: column;
//   box-shadow: inset 0 0 1em #00000026;
//   padding: 40px 5px 20px 20px;
//   background: linear-gradient(135deg, #f5f7fa, #c3cfe2);
//   height: 100%;
// `;

// Main.Wrapper = styled.div`
//   display: flex;
//   flex-direction: column;
//   flex: 1;
//   padding: 20px;
//   overflow-y: auto;
// `;

// Main.Section = styled.div`
//   display: flex;
//   flex-wrap: wrap;
//   justify-content: center;
// `;

// Main.Footer = styled.footer`
//   display: flex;
//   justify-content: flex-end;
//   padding: 10px;
//   background: none;

//   > a {
//     > img {
//       width: 150px;
//       opacity: 0.9;
//     }
//   }
// `;

// const Card = styled(animated.div)`
//   display: flex;
//   position: relative;
//   background: #fff;
//   box-shadow: 0px 6px 12px rgba(0, 0, 0, 0.1);
//   border-radius: 15px;
//   margin: 15px;
//   height: 100%;
//   height: 300px;
//   width: 100%;
//   max-width: 290px;
//   transition: transform 0.3s ease, box-shadow 0.3s ease;

//   &:hover {
//     transform: scale(1.05);
//     box-shadow: 0px 8px 16px rgba(0, 0, 0, 0.2);
//   }

//   > a {
//     display: flex;
//     align-items: center;
//     justify-content: center;
//     font-size: 14px;
//     color: inherit;
//     text-decoration: none;
//     text-align: center;
//     height: 100%;
//     width: 100%;
//     /* border: 1px solid #e5e7eb; */
//     border-radius: 10px;
//     padding: 20px;
//   }
// `;

// Card.Wrapper = styled.div`
//   display: flex;
//   flex-direction: column;
//   align-items: center;
//   text-align: center;
// `;

// Card.Language = styled.div`
//   position: absolute;
//   top: 0;
//   right: 0;
//   padding: 5px;
//   color: #2c405a;
//   /* border: 1px solid #2c405a; */
//   border-radius: 5px;
//   font-size: 10px;
// `;

// Card.Title = styled.h4`
//   margin: 10px 0;
//   color: #2c405a;
// `;

// Card.Image = styled.img`
//   border-radius: 10px;
//   /* width: 100%; */
//   max-width: 200px;
//   max-height: 200px;
//   /* height: 100%; */
//   /* object-fit: cover; */
//   /* box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.1); */
// `;

// Card.Content = styled.span`
//   color: #555;
//   font-size: 14px;
//   margin: 5px 0;
// `;

// Card.Maintenance = styled.div`
//   position: absolute;
//   background: rgba(0, 0, 0, 0.4);
//   top: 0;
//   left: 0;
//   right: 0;
//   bottom: 0;
//   border-radius: 10px;
//   display: flex;
//   align-items: center;
//   justify-content: center;
//   cursor: not-allowed;
// `;

// Card.Maintenance.Content = styled.span`
//   display: flex;
//   align-items: center;
//   gap: 10px;
//   background-color: rgba(255, 255, 255, 0.92);
//   color: #de3b3b;
//   padding: 10px 20px;
//   border-radius: 5px;
//   max-width: 95%;

//   > span {
//     text-align: center;
//   }
// `;

// export { Main, Card };

// StyledThemes.js
import styled from 'styled-components';
import { animated } from 'react-spring';

/* =========================
   Tema Google (Material)
   ========================= */
export const MainGoogle = styled.div`
  flex: 1;
  display: flex;
  height: 100%;
  max-height: calc(100vh - 75px);
  font-family: 'Roboto', sans-serif;

  h2 {
    font-size: 28px;
    font-weight: bold;
    color: #2c405a;
    margin-bottom: 20px;
  }
`;
MainGoogle.Container = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  box-shadow: inset 0 0 1em rgba(0, 0, 0, 0.14);
  padding: 40px 5px 20px 20px;
  background: #f5f5f5;
  height: 100%;
`;
MainGoogle.Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  padding: 20px;
  overflow-y: auto;
`;
MainGoogle.Section = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
`;
MainGoogle.Footer = styled.footer`
  display: flex;
  justify-content: flex-end;
  padding: 10px;
  background: none;

  > a > img {
    width: 150px;
    opacity: 0.9;
  }
`;

export const CardGoogle = styled(animated.div)`
  display: flex;
  position: relative;
  background: #fff;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.14);
  border-radius: 8px;
  margin: 15px;
  height: 300px;
  width: 100%;
  max-width: 290px;
  transition: transform 200ms ease, box-shadow 200ms ease;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
  }

  > a {
    position: relative;
    overflow: hidden;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 14px;
    color: #4285f4;
    text-decoration: none;
    text-align: center;
    height: 100%;
    width: 100%;
    border-radius: 10px;
    padding: 20px;
    font-family: 'Roboto', sans-serif;

    /* Ripple effect */
    &::after {
      content: '';
      position: absolute;
      width: 100px;
      height: 100px;
      background: rgba(66, 133, 244, 0.3);
      border-radius: 50%;
      transform: scale(0);
      opacity: 0;
      transition: transform 0.5s, opacity 1s;
      pointer-events: none;
      top: 50%;
      left: 50%;
      transform-origin: center;
    }
    &:active::after {
      transform: scale(4);
      opacity: 1;
      transition: 0s;
    }
  }
`;
CardGoogle.Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
`;
CardGoogle.Language = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  padding: 5px;
  color: #2c405a;
  border-radius: 5px;
  font-size: 10px;
`;
CardGoogle.Title = styled.h4`
  margin: 10px 0;
  color: #2c405a;
`;
CardGoogle.Image = styled.img`
  border-radius: 10px;
  max-width: 200px;
  max-height: 200px;
`;
CardGoogle.Content = styled.span`
  color: #555;
  font-size: 14px;
  margin: 5px 0;
`;
CardGoogle.Maintenance = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.4);
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: not-allowed;
`;
CardGoogle.Maintenance.Content = styled.span`
  display: flex;
  align-items: center;
  gap: 10px;
  background-color: rgba(255, 255, 255, 0.92);
  color: #de3b3b;
  padding: 10px 20px;
  border-radius: 5px;
  max-width: 95%;

  > span {
    text-align: center;
  }
`;

/* =========================
   Tema Amazon
   ========================= */
export const MainAmazon = styled.div`
  flex: 1;
  display: flex;
  height: 100%;
  max-height: calc(100vh - 75px);
  font-family: 'Arial', sans-serif;

  h2 {
    font-size: 28px;
    font-weight: bold;
    color: #111;
    margin-bottom: 20px;
  }
`;
MainAmazon.Container = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  box-shadow: inset 0 0 1em rgba(0, 0, 0, 0.1);
  padding: 40px 5px 20px 20px;
  background: #f6f6f6;
  height: 100%;
`;
MainAmazon.Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  padding: 20px;
  overflow-y: auto;
`;
MainAmazon.Section = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
`;
MainAmazon.Footer = styled.footer`
  display: flex;
  justify-content: flex-end;
  padding: 10px;
  background: none;

  > a > img {
    width: 150px;
    opacity: 0.9;
  }
`;

export const CardAmazon = styled(animated.div)`
  display: flex;
  position: relative;
  background: #fff;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  border-radius: 4px;
  margin: 15px;
  height: 300px;
  width: 100%;
  max-width: 290px;
  transition: transform 200ms ease, box-shadow 200ms ease;

  &:hover {
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.15);
  }
  &:active {
    transform: scale(0.98);
  }

  > a {
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 14px;
    color: #111;
    text-decoration: none;
    text-align: center;
    height: 100%;
    width: 100%;
    padding: 20px;
    border-radius: 10px;
    font-family: 'Arial', sans-serif;

    &:hover {
      color: #ff9900;
    }
  }
`;
CardAmazon.Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
`;
CardAmazon.Language = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  padding: 5px;
  color: #111;
  border-radius: 5px;
  font-size: 10px;
`;
CardAmazon.Title = styled.h4`
  margin: 10px 0;
  color: #111;
`;
CardAmazon.Image = styled.img`
  border-radius: 10px;
  max-width: 200px;
  max-height: 200px;
`;
CardAmazon.Content = styled.span`
  color: #555;
  font-size: 14px;
  margin: 5px 0;
`;
CardAmazon.Maintenance = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.4);
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: not-allowed;
`;
CardAmazon.Maintenance.Content = styled.span`
  display: flex;
  align-items: center;
  gap: 10px;
  background-color: rgba(255, 255, 255, 0.92);
  color: #de3b3b;
  padding: 10px 20px;
  border-radius: 5px;
  max-width: 95%;

  > span {
    text-align: center;
  }
`;

/* =========================
   Tema Apple
   ========================= */
export const MainApple = styled.div`
  flex: 1;
  display: flex;
  height: 100%;
  max-height: calc(100vh - 75px);
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;

  h2 {
    font-size: 28px;
    font-weight: bold;
    color: #1d1d1f;
    margin-bottom: 20px;
  }
`;
MainApple.Container = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  padding: 40px 5px 20px 20px;
  background: rgba(255, 255, 255, 0.8);
  backdrop-filter: blur(10px);
  height: 100%;
`;
MainApple.Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  padding: 20px;
  overflow-y: auto;
`;
MainApple.Section = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
`;
MainApple.Footer = styled.footer`
  display: flex;
  justify-content: flex-end;
  padding: 10px;
  background: none;

  > a > img {
    width: 150px;
    opacity: 0.9;
  }
`;

export const CardApple = styled(animated.div)`
  display: flex;
  position: relative;
  background: rgba(255, 255, 255, 0.8);
  backdrop-filter: blur(10px);
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  border-radius: 10px;
  margin: 15px;
  height: 300px;
  width: 100%;
  max-width: 290px;
  transition: transform 300ms ease, box-shadow 300ms ease;

  &:hover {
    box-shadow: 0 6px 10px rgba(0, 0, 0, 0.15);
  }

  > a {
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 14px;
    color: #1d1d1f;
    text-decoration: none;
    text-align: center;
    height: 100%;
    width: 100%;
    padding: 24px;
    border-radius: 8px;
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto,
      sans-serif;

    /* &:hover {
      background: #f2f2f2;
    } */
  }
`;
CardApple.Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
`;
CardApple.Language = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  padding: 5px;
  color: #1d1d1f;
  border-radius: 5px;
  font-size: 10px;
`;
CardApple.Title = styled.h4`
  margin: 10px 0;
  color: #1d1d1f;
`;
CardApple.Image = styled.img`
  border-radius: 10px;
  max-width: 200px;
  max-height: 200px;
`;
CardApple.Content = styled.span`
  color: #555;
  font-size: 14px;
  margin: 5px 0;
`;
CardApple.Maintenance = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.4);
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: not-allowed;
`;
CardApple.Maintenance.Content = styled.span`
  display: flex;
  align-items: center;
  gap: 10px;
  background-color: rgba(255, 255, 255, 0.92);
  color: #de3b3b;
  padding: 10px 20px;
  border-radius: 5px;
  max-width: 95%;

  > span {
    text-align: center;
  }
`;
